import {StyleSheet} from "aphrodite";
import React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {
    PhosphorIcon,
    type PhosphorIconAsset,
} from "@khanacademy/wonder-blocks-icon";

import arrowClockwiseIcon from "@phosphor-icons/core/bold/arrow-clockwise-bold.svg";
import warningCircleIcon from "@phosphor-icons/core/bold/warning-circle-bold.svg";
import timerIcon from "@phosphor-icons/core/regular/timer.svg";

// For now this is a one-off solution for message bubbles but if we need to
// we could make this more generic and use it in other places and allow
// consumers to pass in the icons they want to prefetch.
const ICONS: PhosphorIconAsset[] = [
    arrowClockwiseIcon,
    timerIcon,
    warningCircleIcon,
];

/**
 * Prefetches icons used in Khanmigo message bubbles in poor network
 * conditions which allows the icons to be available in the event of a
 * disconnected network. These are hidden off-screen and are non-interactive.
 */
export const PrefetchMessageBubbleIcons = React.memo(() => (
    <View tabIndex={-1} style={[styles.hidden, styles.noninteractive]}>
        {ICONS.map((icon) => (
            <PhosphorIcon key={icon} icon={icon} />
        ))}
    </View>
));

const styles = StyleSheet.create({
    hidden: {
        position: "absolute",
        visibility: "hidden",
        top: "-100%",
        insetInlineStart: "-100%",
    },
    noninteractive: {
        pointerEvents: "none",
        userSelect: "none",
    },
});
